module.exports = __webpack_public_path__ + "static/img/referrer5.249a177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/referrer5.png
// module id = o8DD
// module chunks = 1